import { Home } from "../presentation/components/home/home2.js";
import { HomeRoutes } from "./routes.js";
import { jsx } from "react/jsx-runtime";
//#region src/router/router.tsx
var homeRouter = {
	path: HomeRoutes.HOME,
	children: [{
		index: true,
		element: /* @__PURE__ */ jsx(Home, {})
	}]
};
//#endregion
export { homeRouter };

//# sourceMappingURL=router.js.map